import { Button, Paper, Title, Stack, Alert, Text } from '@mantine/core';
import { IconAlertCircle, IconBrandGoogle } from '@tabler/icons-react';

interface LoginFormProps {
  onGoogleSignIn: () => void;
  loading: boolean;
  error: string | null;
}

export function LoginForm({ onGoogleSignIn, loading, error }: LoginFormProps) {
  return (
    <Paper p="xl" radius="md" withBorder maw={400} mx="auto" mt={100}>
      <Title order={2} ta="center" mb="lg">
        Shipment Tracker
      </Title>

      <Text c="dimmed" ta="center" mb="xl">
        Sign in with your Tom &amp; Sawyer Google account
      </Text>

      {error && (
        <Alert
          icon={<IconAlertCircle size={16} />}
          color="red"
          mb="md"
          title="Error"
        >
          {error}
        </Alert>
      )}

      <Stack>
        <Button
          leftSection={<IconBrandGoogle size={20} />}
          fullWidth
          loading={loading}
          onClick={onGoogleSignIn}
          variant="default"
          size="lg"
        >
          Sign in with Google
        </Button>
      </Stack>
    </Paper>
  );
}
